/**
 * @file Defines the actions related to the menu state.
 */
export namespace Menus {

  export class LoadValidDashboardPaths {
    static readonly type = '[Menus] Load Valid Dashboard Paths';
  }
}

